/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoanTierDto
 */
export interface LoanTierDto {
    /**
     * Duration of the tier in months
     * @type {number}
     * @memberof LoanTierDto
     */
    duration?: number | null;
    /**
     * Amount for this tier
     * @type {number}
     * @memberof LoanTierDto
     */
    amount?: number | null;
    /**
     * Rate for this tier
     * @type {number}
     * @memberof LoanTierDto
     */
    rate?: number | null;
}

/**
 * Check if a given object implements the LoanTierDto interface.
 */
export function instanceOfLoanTierDto(value: object): value is LoanTierDto {
    return true;
}

export function LoanTierDtoFromJSON(json: any): LoanTierDto {
    return LoanTierDtoFromJSONTyped(json, false);
}

export function LoanTierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoanTierDto {
    if (json == null) {
        return json;
    }
    return {
        
        'duration': json['duration'] == null ? undefined : json['duration'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'rate': json['rate'] == null ? undefined : json['rate'],
    };
}

export function LoanTierDtoToJSON(json: any): LoanTierDto {
    return LoanTierDtoToJSONTyped(json, false);
}

export function LoanTierDtoToJSONTyped(value?: LoanTierDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'duration': value['duration'],
        'amount': value['amount'],
        'rate': value['rate'],
    };
}

